import React from 'react';
import './Mpseriesapplicati.css';
import BJMSeries from '../../../imgs/MPSeriesapplicati.webp'; 

const Mpseriesapplicati = () => {
  return (
    <div className="Mpseriesapp-container" data-aos="fade-down">
      <img src={BJMSeries} alt="Fitting Corrosion" className="Mpseriesapp-image" />
    </div>
  );
};

export default Mpseriesapplicati;
